export default "__VITE_ASSET__0b3d099e__"